require('./index.less');
require('./enhancer.js');

var locale = require('./i18n');

var tpl = require('./index.html');
var hash = require('./hash');
var isSmallScreen = $('body').width() < 720;

var loginPage = {
    init: function() {
        var that = this;
        var settings = window.loginPageSettings;

        settings.beforeLogin = '(function() {' + (settings.beforeLoginScript || '') + '\n})'; 

        try {
            settings.beforeLogin = eval(settings.beforeLogin);
        } catch(e) {
            alert(locale('beforeLoginScriptError', {
                reason: e.message
            }));
            settings.beforeLogin = function() {};
        }

        // Set mode
        $('body').addClass((settings.style || 'right') + '-mode')
            .html(tpl({
                projectTitle: window.projectTitle,
                locale: locale(),
                logoUrl: window.logoUrl
            }));

        if (window.logoUrl) {
            $('img.logo').css({
                height: (settings.logoHeight || 72) + 'px',
                marginTop: -(settings.logoHeight || 72) + 'px'
            });
        } else {
            $('img.logo').hide();
        }

        // Set background
        if (settings.backgroundImgUrl) {
            $('body').css({
                backgroundImage: 'url("' + settings.backgroundImgUrl + '")',
            });

            var transparency = (settings.transparency === 0 
                || settings.transparency  === '' 
                || typeof settings.transparency === 'undefined')
                ? 0.9 : settings.transparency;
            var opacity = 1 - settings.transparency;
            $('.bg-mask').css('opacity', opacity);
        }

        $('.project-title').css({
            fontSize: (settings.titleFontSize || 28) + 'px',
            fontWeight: settings.titleFontWeight || 'normal'
        });

        if (enableVeriCode === false) {
            $('.login').addClass('no-veri-code')
                .find('.veri-code-line').remove();
        } else {
            $('.refresh-code').on('click', function() {
                that.refreshCode();
            });
            $('.captcha').on('click', function() {
                that.refreshCode();
            });
            that.refreshCode();
        }

        // Set login
        $('.login-btn').button()
            .click(function() {
                $('.tips').html('').removeClass('ui-state-error');
                var uid = $('.uid').val();
                var pwd = $('.pwd').val();
                var vcode = $('.code').val();
                if (!uid || !pwd) {
                    $('.tips').addClass('ui-state-error')
                        .html(locale('nullTips'));
                    return;
                }
                if (enableVeriCode !== false && !vcode) {
                    $('.tips').addClass('ui-state-error')
                        .html(locale('inputCodeTips'));
                        return;
                }
                pwd = hash.digest(window.hashType, pwd);

                var context;
                try {
                    context = settings.beforeLogin();
                } catch (e) {
                    alert(locale('exeBeforeLoginScriptError', {reason: e.message}));
                    return
                }
                if (context === false) {
                    return
                }
                var loginURL = window.location.pathname.replace(/\/$/, '');
                $.ajax({
                    url:  loginURL + '/do',
                    dataType: 'json',
                    data: {
                        uid: uid,
                        pwd: pwd,
                        code: vcode || '',
                        context: JSON.stringify(context || {})
                    },
                    type: 'post',
                    success: function(result) {
                        if (!result.success) {
                            var msg = result.code ? locale(result.code) : result.message;
                            $('.tips').addClass('ui-state-error').html(msg);
                            that.refreshCode();
                        } else {

                            var rd = location.search.match(/redirect=([^&]+)/);
                            if (rd) {
                                return location.href = decodeURIComponent(rd[1]);
                            }
                            var href = homePageURL;
                            if (location.hash) {
                                if (isSmallScreen) {
                                    href = href + location.hash.replace('#', '/m/');
                                } else {
                                    href = href + location.hash
                                }
                            } 
                            // else if (isSmallScreen) {
                            //     href = href + '/m';
                            // }
                            location.href = href;
                        }
                    },
                    error: function(e) {
                        alert(locale('loginException'));
                        console.error(e);
                        that.refreshCode();
                    }
                });
        });


        $(window).keyup(function(e) {
            if (e.keyCode === 13) {
                $('.login-btn').focus().click();
            }
        });

        if (settings.noAnimation) {
            if (isSmallScreen) {
                $('.login').css('top','50%');
            } else {
                if (settings.style !== 'center') {
                    $('.login-bg').css({
                        width: '38.2%',
                        minWidth: '388px'
                    });
                    $('.login').css('top','50%');
                } else {
                    $('.login-bg').css({
                        height: '61.8%'
                    });
                    $('.login').show();
                }
            }
            return
        }

        // Run animation
        if (!isSmallScreen) {
            if (settings.style !== 'center') {
                $('.login-bg').animate({
                    width: '38.2%'
                }, 300, 'easeOutQuad', function() {
                    $('.login-bg').css('min-width', '388px');
                    $('.login').animate({top: '50%'}, 500, 'easeOutBounce');
                });
            } else {
                $('.login-bg').animate({
                    height: '61.8%'
                }, 500, 'easeOutQuad', function() {
                    $('.login-bg').css('min-height', '370px');
                    $('.login').show('drop', 300);
                });
            }
        } else {
            $('.login').css('top', '80%')
                .animate({
                    top: '50%'
                }, 500, 'easeOutQuint');
        }
    },
    refreshCode: function() {
        if (window.captchaUrl) {
            $('.captcha').attr('src', window.captchaUrl + '?t=' + new Date().getTime());
        }
    }
};

$(function() {
    loginPage.init();
});


//////////////////
// WEBPACK FOOTER
// ./src/pages/login/index.js
// module id = 0
// module chunks = 0